'use es6';

import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { getPortalMigrationStatus, getPortalMigrationStartDate } from 'EmailData/selectors/portalMigration';
import { dashboardType, noMigrationsCategory } from 'EmailData/constants/portalMigration';
import { getNumberofDaysBetweenDates } from 'EmailComponents/utils/portalMigration';
import { getHasAccessToSeamlessPortalMigration } from 'EmailData/selectors/user';
import { portalMigrationLearnMoreLink } from 'EmailData/constants/portalMigration';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PortalMigrationBanner({
  type = dashboardType,
  marginBlockEnd,
  onClose
}) {
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  const portalMigrationStatus = useSelector(getPortalMigrationStatus);
  const portalMigrationStartDate = useSelector(getPortalMigrationStartDate);
  const hasAccessToSeamlessPortalMigration = useSelector(getHasAccessToSeamlessPortalMigration);
  if (!hasAccessToSeamlessPortalMigration || noMigrationsCategory.includes(portalMigrationStatus)) {
    return null;
  }
  const onCloseBanner = () => {
    setIsBannerVisible(false);
    onClose();
  };
  const diffDays = getNumberofDaysBetweenDates(portalMigrationStartDate);
  const shouldShowMigrationBanner = diffDays >= 0 && diffDays <= 3;
  const isDashboardBanner = type === dashboardType;
  const messageOptions = {
    migrationStartDate: /*#__PURE__*/_jsx(FormattedDateTime, {
      value: portalMigrationStartDate,
      format: "medium-full-date"
    })
  };
  const bannerTitle = isDashboardBanner ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: `EmailComponents.seamlessPortalMigration.dashboardBanner.title`
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `EmailComponents.seamlessPortalMigration.sendTabBanner.title`,
    options: messageOptions
  });
  return shouldShowMigrationBanner && isBannerVisible && /*#__PURE__*/_jsx(Alert, {
    "data-test-id": "portal-migration-banner",
    titleText: bannerTitle,
    type: "info",
    closeable: isDashboardBanner,
    onClose: onCloseBanner,
    marginBlockEnd: marginBlockEnd,
    children: isDashboardBanner ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        KnowledgeBaseButton
      },
      message: `EmailComponents.seamlessPortalMigration.dashboardBanner.message_jsx`,
      options: Object.assign({}, messageOptions, {
        kbLink: portalMigrationLearnMoreLink
      })
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: `EmailComponents.seamlessPortalMigration.sendTabBanner.message`
    })
  });
}